import { useMemo } from "react";
import { useSelector } from "react-redux";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { Loading } from "../../components/Loading";
import { Pagination } from "../../components/Pagination";
import useQueryString from "../../../utils/hooks/useQueryString";
import ErrorMessageBox from "../../components/ErrorMessageBox";
import { UserProfileInline } from "app/components/UserProfileInline";
import { useQuery, keepPreviousData } from "@tanstack/react-query";
import Api, { createFetchErrorMessage } from "utils/api/Api";
import { scrollToElement } from "lib/userFunctions";
const queryString = require("query-string");

export const BoardQnaList = () => {
    const { school } = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const queryParams = useQueryString();

    const auth = useSelector((state) => state.auth);


    const requestData = useMemo(() => {
        const paramJson = { page: 0, user: 'N', school: '' };
        return { ...paramJson, ...queryParams, school: queryParams.schoolCode };
    }, [queryParams]);

    const { data: qnaList, isFetching, isError, error, isSuccess } = useQuery({
        queryKey: ['board/qna/list', requestData],
        queryFn: () => Api.post(`/api/board/qna?page=${requestData.page}`, requestData),
        placeholderData: keepPreviousData
    });

    const fetchList = (page = 0) => {
        let tempSearchOption = { ...requestData, page };
        scrollToElement();
        navigate(`/${school}/board/qna?${queryString.stringify(tempSearchOption)}`);
    }

    const list = useMemo(() => {
        if (isError) return <ErrorMessageBox message={createFetchErrorMessage(error).message} />;
        if (qnaList?.data?.list.length <= 0) {
            if (isFetching) return <Loading />;
            return <div className="no_data">게시글이 없습니다.</div>;
        }

        return qnaList?.data?.list.map((board) => {
            return (
                <div className="list" key={board.id}>
                    <div className="num">{board.id}</div>
                    <div className="school">
                        {board.user?.schoolName?.replace("초등학교", "초 ")}
                    </div>
                    <div className="title">
                        <Link to={`/${school}/board/qna/view/${board.id}${location.search}`} >
                            {board.state === "ANSWER" && <span className="reply reply_y">답변</span>}
                            {board.state === "WAITING" && <span className="reply reply_n">대기</span>}
                            {board.title}
                            {board.isSecret === "Y" && <i className="icon fas fa-lock"></i>}
                        </Link>
                    </div>
                    <div className="writer align-left">
                        <UserProfileInline id={board?.user?.id} name={board?.user?.name || board?.name} image={board?.user?.image} />
                    </div>
                    <div className="date">
                        {board.createdAt.substring(0, 10).replace(/-/gi, ".")}
                    </div>
                </div>
            );
        });
    }, [error, isError, isFetching, location, qnaList, school]);

    return (
        <div className="section">
            <div className="inner">
                <div className="bbs_nav">
                    <ul>
                        <li className={requestData.user === undefined || requestData.schoolCode === undefined || (requestData.user === "N" && requestData.schoolCode !== school) ? "on" : ""}>
                            <Link className="btn _sm _border" to={`/${school}/board/qna?user=N&schoolCode=&page=0`}>
                                전체
                            </Link>
                        </li>
                        <li className={requestData.schoolCode === school ? "on" : ""}>
                            <Link className="btn _sm _border" to={`/${school}/board/qna?page=0&user=N&schoolCode=${school}`}>우리학교</Link>
                        </li>
                        {auth.authenticated && (
                            <>
                                <li className={requestData.user === "Y" ? "on" : ""}>
                                    <Link className="btn _sm _border" to={`/${school}/board/qna?page=0&user=Y&schoolCode=`}>나의 문의</Link>
                                </li>
                                <li className="floatR">
                                    <Link className="btn _blue" to={`/${school}/board/qna/create`}>글쓰기</Link>
                                </li>
                            </>
                        )}
                    </ul>
                </div>

                <div className="bbs_list">
                    <div className="list devision">
                        <div className="num">번호</div>
                        <div className="school">학교</div>
                        <div className="title">제목</div>
                        <div className="writer">글쓴이</div>
                        <div className="date">등록일</div>
                    </div>
                    {list}
                    <Loading overlay={true} active={isFetching} />
                </div>

                {isSuccess && <Pagination page={qnaList.data?.page} totalPage={qnaList.data?.totalPages} gotoPage={fetchList} />}
            </div>
        </div>
    );
};